/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION - COMMENT VOLUME: STYLES --------------- ++++++++++ */
export default theme => ({
  userprofileabout: {
    '& > .content': {
      borderLeft: 'none !important',
      paddingLeft: `0 !important`
    },
    '& .explainer': {
      width: '100%'
    },
    '& .previewconfig': {
      marginTop: pxToEm(-50) // move this up a bit to improve the visual awkwardness
    }
  }
});
